const getXAxisPointsFor0To24Months = function () {
  var xAxisPoints = [
    '0',
    '1',
    '2',
    '3',
    '4',
    '5',
    '6',
    '7',
    '8',
    '9',
    '10',
    '11',
    '12',
    '13',
    '14',
    '15',
    '16',
    '17',
    '18',
    '19',
    '20',
    '21',
    '22',
    '23',
    '24',
  ];
  return xAxisPoints;
};

const getXAxisPointsFor2To20Years = function () {
  var xAxisPoints = [];
  for (var i = 24; i <= 240; i++) {
    xAxisPoints.push(i);
  }
  return xAxisPoints;
};

const getXAxisPointsFor21To100Years = function () {
  var xAxisPoints = [];
  for (var i = 288; i <= 1200; i++) {
    xAxisPoints.push(i);
  }
  return xAxisPoints;
};

const getYAxisDataPointsForWeightChartByUnit = function (unit, age) {
  var dataPoint = {};

  if (age < 25) {
    if (unit === 'kgs') {
      dataPoint = {
        min: 0,
        max: 20,
        tickInterval: 1,
      };
    }

    if (unit === 'lbs') {
      dataPoint = {
        min: 0,
        max: 40,
        tickInterval: 5,
      };
    }
  } else {
    if (unit === 'kgs') {
      dataPoint = {
        min: 0,
        max: 100,
        tickInterval: 10,
      };
    }

    if (unit === 'lbs') {
      dataPoint = {
        min: 0,
        max: 225,
        tickInterval: 25,
      };
    }
  }

  return dataPoint;
};

const getYAxisDataPointsForLengthChartByUnit = function (unit, age) {
  var dataPoint = {};

  if (age <= 24) {
    if (unit === 'cms') {
      dataPoint = {
        min: 40,
        max: 100,
        tickInterval: 5,
      };
    }

    if (unit === 'inches') {
      dataPoint = {
        min: 16,
        max: 40,
        tickInterval: 2.5,
      };
    }
  } else {
    if (unit === 'cms') {
      dataPoint = {
        min: 75,
        max: 200,
        tickInterval: 20,
      };
    }

    if (unit === 'inches') {
      dataPoint = {
        min: 0,
        max: 75,
        tickInterval: 5,
      };
    }
  }

  return dataPoint;
};

const getYAxisDataPointsForHeadChartByUnit = function (unit, age) {
  var dataPoint = {};

  if (age <= 24) {
    if (unit === 'cms') {
      dataPoint = {
        min: 30,
        max: 55,
        tickInterval: 1,
      };
    }

    if (unit === 'inches') {
      dataPoint = {
        min: 11,
        max: 25,
        tickInterval: 1,
      };
    }
  } else {
    if (unit === 'cms') {
      dataPoint = {
        min: 30,
        max: 100,
        tickInterval: 5,
      };
    }

    if (unit === 'inches') {
      dataPoint = {
        min: 11,
        max: 55,
        tickInterval: 5,
      };
    }
  }
  return dataPoint;
};

const getYAxisDataPointsForBMIChartByUnit = function () {
  var dataPoint = {
    min: 0,
    max: 40,
    tickInterval: 1,
  };

  return dataPoint;
};

export {
  getXAxisPointsFor0To24Months,
  getXAxisPointsFor2To20Years,
  getYAxisDataPointsForBMIChartByUnit,
  getYAxisDataPointsForHeadChartByUnit,
  getYAxisDataPointsForLengthChartByUnit,
  getYAxisDataPointsForWeightChartByUnit,
  getXAxisPointsFor21To100Years,
};
